/**
 * Depoimentos de clientes (somente os publicados no Painel Super Admin).
 * A seção não é renderizada enquanto não houver depoimentos reais publicados.
 */

import { Quote, Star } from 'lucide-react';
import { Testimonial } from '@services/platformService';
import { SEGMENTS } from '../content';
import { Reveal, SectionHeading } from './Reveal';

export function Testimonials({ items }: { items: Testimonial[] }) {
  if (items.length === 0) return null;
  return (
    <section id="depoimentos" className="relative scroll-mt-20 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Quem usa, recomenda"
          title={
            <>
              Histórias de quem <span className="vw-gradient-text">vende mais sem comissão</span>
            </>
          }
        />
        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((t, i) => {
            const segment = SEGMENTS.find(s => s.type === t.segment)?.label;
            return (
              <Reveal
                key={t.id}
                delay={i * 80}
                as="figure"
                className="flex flex-col rounded-3xl border border-white/10 bg-white/[0.03] p-7"
              >
                <Quote size={28} className="text-violet-400/60" aria-hidden />
                <div className="mt-4 flex text-amber-300" aria-label={`${t.rating} de 5 estrelas`}>
                  {Array.from({ length: 5 }).map((_, n) => (
                    <Star
                      key={n}
                      size={16}
                      className={n < t.rating ? 'fill-current' : 'text-slate-600'}
                    />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 leading-relaxed text-slate-200">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3">
                  {t.avatarUrl ? (
                    <img
                      src={t.avatarUrl}
                      alt=""
                      className="h-11 w-11 rounded-full object-cover"
                      loading="lazy"
                    />
                  ) : (
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-violet-600 to-fuchsia-600 font-semibold text-white">
                      {t.authorName.charAt(0).toUpperCase()}
                    </span>
                  )}
                  <span>
                    <span className="block font-semibold text-white">{t.authorName}</span>
                    <span className="block text-sm text-slate-400">
                      {t.businessName}
                      {segment ? ` · ${segment}` : ''}
                      {t.city ? ` · ${t.city}` : ''}
                    </span>
                  </span>
                </figcaption>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
